export enum CrudViewColumnType {
  DateTime = 'datetime',
  Date = 'date',
  Tag = 'tag',
  TagList = 'tag-list',
  Icon = 'icon',
  Text = 'text',
  Boolean = 'boolean',
  Number = 'number',
  Link = 'link',
  Image = 'image',
  Currency = 'currency',
  Rate = 'rate',
  Switch = 'switch',
  ActionLink = 'action-link',
  Code = 'code',
  InputTemplate = 'input-template',
  PhoneNumber = 'phone-number'
}
